import Tooltip from 'tooltip.js'

export default function(app) {

    $('[data-tooltip-text]').each(function(index, el){

        const extraClass = el.getAttribute('data-tooltip-theme')

        const template =
            `<div class="tooltip ${extraClass}" role="tooltip">
                <div class="tooltip-arrow"></div>
                <div class="tooltip-inner"></div>
            </div>`

        new Tooltip(el,{
            title: el.getAttribute('data-tooltip-text'),
            trigger: 'hover',
            placement: el.getAttribute('data-tooltip-position') || 'top',
            html: el.getAttribute('data-tooltip-html') || false,
            container: 'main',
            delay: {
                show: el.getAttribute('data-tooltip-show-delay'),
                hide: 0
            },
            template
        })
    })

}
